import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../../context/AuthContext';


const Header = () => {
  const { currentUser, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get current path to highlight active nav item
  const currentPath = location.pathname;

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <HeaderContainer>
      <HeaderContent>
        <LogoContainer>
          <LogoText>Opplane</LogoText>
        </LogoContainer>

        {currentUser && (
          <NavContainer>
            {isAdmin() ? (
              <>
                <NavLink to="/admin" active={currentPath === "/admin"}>Dashboard</NavLink>
                <NavLink to="/admin/upload" active={currentPath === "/admin/upload"}>Upload Image</NavLink>
                <NavLink to="/admin/registration-requests" active={currentPath === "/admin/registration-requests"}>Registration Requests</NavLink>
              </>
            ) : (
              <NavLink to="/client" active={currentPath === "/client"}>Dashboard</NavLink>
            )}
            <UserInfo>
              <UserName>{currentUser.email}</UserName>
              <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
            </UserInfo>
          </NavContainer>
        )}
      </HeaderContent>
    </HeaderContainer>
  );
};

// Styled components
const HeaderContainer = styled.header`
  background-color: ${props => props.theme.colors.verizonWhite};
  color: ${props => props.theme.colors.opplaneBlue};
  padding: ${props => props.theme.spacing.md};
  box-shadow: ${props => props.theme.shadows.medium};
  border-bottom: 1px solid #e0e0e0;
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LogoText = styled.h1`
  font-size: ${props => props.theme.fontSizes.large};
  font-weight: bold;
  margin: 0;
  color: ${props => props.theme.colors.opplaneBlue};
`;

const NavContainer = styled.nav`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.lg};
`;

const NavLink = styled(Link)`
  color: ${props => props.active ? props.theme.colors.opplaneBlue : props.theme.colors.verizonBlack};
  font-weight: ${props => props.active ? 'bold' : '500'};
  text-decoration: none;
  padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.sm};
  border-radius: ${props => props.theme.borderRadius.small};
  transition: ${props => props.theme.transitions.short};
  background-color: ${props => props.active ? 'rgba(0, 102, 204, 0.1)' : 'transparent'};
  border-bottom: ${props => props.active ? `2px solid ${props.theme.colors.opplaneBlue}` : 'none'};

  &:hover {
    background-color: ${props => props.active ? 'rgba(0, 102, 204, 0.1)' : 'rgba(0, 0, 0, 0.05)'};
    color: ${props => props.theme.colors.opplaneBlue};
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.md};
  margin-left: ${props => props.theme.spacing.lg};
`;

const UserName = styled.span`
  font-size: ${props => props.theme.fontSizes.small};
  color: ${props => props.theme.colors.text};
`;

const LogoutButton = styled.button`
  background-color: transparent;
  color: ${props => props.theme.colors.opplaneBlue};
  border: 1px solid ${props => props.theme.colors.opplaneBlue};
  border-radius: ${props => props.theme.borderRadius.small};
  padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.md};
  font-size: ${props => props.theme.fontSizes.small};
  cursor: pointer;
  transition: ${props => props.theme.transitions.short};

  &:hover {
    background-color: ${props => props.theme.colors.opplaneBlue};
    color: ${props => props.theme.colors.verizonWhite};
  }
`;

export default Header;
